import React from 'react';
import { Hero } from '../components/Hero';
import { WhatWeDo } from '../components/WhatWeDo';
import { HowItWorks } from '../components/HowItWorks';
import { Services } from '../components/Services';
import { WhoWeServe } from '../components/WhoWeServe';
import { Pricing } from '../components/Pricing';
import { Testimonials } from '../components/Testimonials';
export function HomePage() {
  return <>
      <Hero data-id="element-371" />
      <WhatWeDo data-id="element-372" />
      <HowItWorks data-id="element-373" />
      <Services data-id="element-374" />
      <WhoWeServe data-id="element-375" />
      <Pricing data-id="element-376" />
      <Testimonials data-id="element-377" />
    </>;
}